import { render, staticRenderFns } from "./PhoneButton.vue?vue&type=template&id=54900e6f&"
import script from "./PhoneButton.vue?vue&type=script&lang=js&"
export * from "./PhoneButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports